import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";
import {
  ExternalTyreUrlResponse,
  VehicleSearchResponse,
  WorkshopSystemEnum
} from "src/domain/client";
import { IActiveWorkshopSystemResponseBusinessProposal } from "src/app/classes/active-workshop-system-response-business-proposal";
import { FormService } from "src/app/services/form.service";
import { IconService } from "src/app/services/icon.service";
import { PagingService } from "src/app/services/paging.service";
import { BusinessProposalService } from "src/app/services/business-proposal.service";
import { LoadingComponent } from "../../layout/loading/loading.component";
import { InfoCardComponent } from "../../layout/info-card/info-card.component";
import { BrandCardComponent } from "../../layout/brand-card/brand-card.component";
import { CheckboxCardComponent } from "../../layout/checkbox-card/checkbox-card.component";
import { RejectProposalDialogComponent } from "../../layout/reject-proposal-dialog/reject-proposal-dialog.component";
import { CarBrandPipe } from "src/app/pipes/car-brand.pipe";

@Component({
  selector: "app-specs-right-column",
  templateUrl: "./specs-right-column.component.html",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LoadingComponent,
    InfoCardComponent,
    BrandCardComponent,
    CheckboxCardComponent,
    ReactiveFormsModule,
    TranslateModule,
    CarBrandPipe
  ]
})
export class SpecsRightColumnComponent {
  isPartialLoading = input(false);
  carInfo = input<VehicleSearchResponse | null>(null);
  externalTyreUrlResponse = input<ExternalTyreUrlResponse | null>(null);
  selectedWorkshopSystems = input<WorkshopSystemEnum[] | null>(null);

  WorkshopSystemEnum = WorkshopSystemEnum;

  constructor(
    public formService: FormService,
    public iconService: IconService,
    public businessProposalService: BusinessProposalService,
    private dialog: MatDialog,
    private pagingService: PagingService
  ) {}

  getFilteredWorkshopSystems(): IActiveWorkshopSystemResponseBusinessProposal[] {
    return (
      this.formService
        .activeWorkshopSystemsResponse as IActiveWorkshopSystemResponseBusinessProposal[]
    ).filter(
      (item) =>
        !item.selectedFromBusinessProposal &&
        item.workshopSystemId !== WorkshopSystemEnum.Other
    );
  }

  openRejectBusinessProposal(e: MouseEvent): void {
    e.preventDefault();

    const ref = this.dialog.open<
      RejectProposalDialogComponent,
      null,
      { rejected?: boolean } | undefined
    >(RejectProposalDialogComponent, {
      width: "500px",
      maxWidth: "90%"
    });

    ref.afterClosed().subscribe((results) => {
      if (results?.rejected) {
        this.pagingService.navigateToProposalRejected();
      }
    });
  }
}
